/* -------------- Operation based interfaces -------------- */

// LIST
export interface DocCategoryListItem {
	categoryId: string;
	categoryNo?: number;
	name: string;
	url: string;
	creationDate: string;
}

export interface DocCategoryListApiResponse {
	result: {
		items: DocCategoryListItem[];
	};
	error: string | null;
    isSuccessful: boolean;
}

// GET
export interface DocCategoryDetail {
	categoryId: string;
	categoryNo?: number;
	name: string;
}

export interface DocCategoryGetApiResponse {
	result: {
		categoryId: string;
		categoryNo?: number;
		name: string;
	}
	error: string | null;
	isSuccessful: boolean;
}

// ADD/UPDATE
export interface DocCategoryFormData {
	name: string;
	categoryNo?: number;
	documents?: File[];
	categoryId?: string;
}

export const defaultDocCategoryData: DocCategoryFormData = {
	categoryId: "",
	categoryNo: undefined,
	name: "",
	documents: [],
};

// Page States
export type OperationStatus =
	| { type: "idle" }
	| { type: "loading"; operation: "add" | "fetch" | "update" | "delete" }
	| { type: "error"; operation: string; message: string };


